
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface ActivitiesHeaderProps {
  onAddActivity: () => void;
}

export const ActivitiesHeader = ({ onAddActivity }: ActivitiesHeaderProps) => {
  return (
    <div className="flex justify-between items-center">
      <h2 className="text-2xl font-bold">Activities Management</h2>
      <Button onClick={onAddActivity}>
        <Plus className="h-4 w-4 mr-2" />
        Add Activity
      </Button>
    </div>
  );
};
